window.initPlugins = function(elem) {

    elem.find('.hamburger').hamburgerMenu();
    elem.find('.toggle-listing-checkboxes').toggleListingCheckboxes();
    elem.find('.submit-on-change').submitOnChange();
    elem.find('.listing-table-header').listingTableHeader();
    elem.find('.tooltip').tooltipster({
        maxWidth: '350px'
    });

    elem.find('.opt-in').optIn();
    elem.find('.opt-in-accept').optInAccept();
    elem.find('.open-overlay').openOverlay();
    elem.find('.inline-overlay').inlineOverlay();

    elem.find('form.single-steps').formSingleSteps({
        scrollEasing: 'easeInOutQuad',
        scrollDuration: 300
    });
    elem.find('form.ticket-preview-form').formTicketPreview({});
    elem.find('form.validate').formValidate();
    elem.find('.toggle-optional-rows').toggleOptionalRows();
    elem.find('.required, .validate').validate();
    elem.find('.clonable').clonableControl();
    elem.find('.number-input').numberInput();
    elem.find('.confirm').confirmDialog();
    elem.find('.notes').notesForm();
    elem.find('.header-message').headerMessage({
        duration: 5000
    });

    // Charts
    elem.find('.chart-three-bars').chartThreeBars();
    elem.find('.chart-stacked-bar').chartTwoBars();

    // Guided Tour
    elem.find('.guided-tour').guidedTour();
    elem.find('.tour-image').guidedTourImage();

    //Help (Glossary & FAQ)
    elem.find('.help-topics').helpTopics();


    //ScrollDupliacte
    elem.find('.scroll-duplicate').parallelScroll();
    // Selects
    if ($('html').hasClass('no-touch')) { // use standard select for touch devices
        elem.find('.select2.basic-select').each(function() {
            var parent = $(this).parent();
            if ($(this).parents('.overlay').length) {
                parent = elem;
            }
            
            $(this).select2({
                minimumResultsForSearch: Infinity,
                placeholder: $(this).attr('placeholder'),
                dropdownParent: parent
            });
        });
        elem.find('.select2.select-clearable').each(function() {
            var parent = $(this).parent();
            if ($(this).parents('.overlay').length) {
                parent = elem;
            }
            
            $(this).select2({
                minimumResultsForSearch: Infinity,
                allowClear: true,
                placeholder: $(this).attr('placeholder'),
                dropdownParent: parent
            });
        });
        elem.find('.select2.select-searchable').each(function() {
            var parent = $(this).parent();
            if ($(this).parents('.overlay').length) {
                parent = elem;
            }

            $(this).select2({
                placeholder: $(this).attr('placeholder'),
                dropdownParent: parent
            });
        });
    } else {
        // add placeholder to select
        elem.find('.select2').each(function() {
            if ($(this).attr('placeholder') && !$(this).find('option').first().text().trim()) {
                $(this).find('option').first().text($(this).attr('placeholder'));
            }
        });
    }
};
window.reInitSelect = function () {
    if ($('html').hasClass('no-touch')) { // use standard select for touch devices
        $('body').find('.select2.basic-select').each(function() {
            var parent = $(this).parent();
            if ($(this).parents('.overlay').length) {
                parent = elem;
            }
            
            $(this).select2('destroy').select2({
                minimumResultsForSearch: Infinity,
                placeholder: $(this).attr('placeholder'),
                dropdownParent: parent
            });
        });
        $('body').find('.select2.select-clearable').each(function() {
            var parent = $(this).parent();
            if ($(this).parents('.overlay').length) {
                parent = elem;
            }
            
            $(this).select2('destroy').select2({
                minimumResultsForSearch: Infinity,
                allowClear: true,
                placeholder: $(this).attr('placeholder'),
                dropdownParent: parent
            });
        });
        $('body').find('.select2.select-searchable').each(function() {
            var parent = $(this).parent();
            if ($(this).parents('.overlay').length) {
                parent = elem;
            }

            $(this).select2('destroy').select2({
                placeholder: $(this).attr('placeholder'),
                dropdownParent: parent
            });
        });
    } else {
        // add placeholder to select
        $('body').find('.select2').each(function() {
            if ($(this).attr('placeholder') && !$(this).find('option').first().text().trim()) {
                $(this).find('option').first().text($(this).attr('placeholder'));
            }
        });
    }
};
jQuery(document).ready(function() {
    window.optInUrlAfter = false;
    initPlugins($('body'));
    // reInitSelect($('body'));
    $('body').overlay();
    // $('body').inlineOverlay();
    $('body').stickyFooter();
    $(window).on('resize', function () {
        reInitSelect();
    });
});
